export default function get(entity, path) {
  var current = entity;

  for (var i = 0; i < path.length; i += 1) {
    if (current === null || current === undefined) {
      return undefined;
    }

    current = current[path[i]];
  }

  return current;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-field-form/node_modules/rc-util/es/utils/get.js
// module id = 199
// module chunks = 0